import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {SentryErrorService} from "@shared/services/sentry-error.service";

export enum STATUS {
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  INTERNAL_SERVER_ERROR = 500,
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private toastr: ToastrService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next
      .handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => this.handleError(error, request.headers.has('x-intercept-test-base')))
      );
  }

  private handleError(error: HttpErrorResponse, shouldIgnored: boolean) {
    if(shouldIgnored) {
      return throwError(error);
    }

    console.error('ERROR', error);
    SentryErrorService.captureException(error).then();
    this.toastr.error(error.error?.msg || error.error?.error?.msg || `${error.status} ${error.statusText}`);
    if (error.status === STATUS.UNAUTHORIZED) {
      this.router.navigateByUrl('/auth/login');
    }

    return throwError(error);
  }
}
